<style scoped>
    .zzuiTable {
        position: relative;
        min-height: 268px;
    }
    .table-bottom {
        margin-top: 20px;
        height: 35px;
        padding-right: 20px;
        width: 100%;
        overflow: hidden;
    }
    .table-btmRight {
        float: right;
    }
    /deep/ table{
        background: none;
        border-collapse: separate; 
        border-spacing: 0px 5px;
    }
    /deep/ table th{
        background: #1B4C4C;
        color: #02E7E7;
    }
    /deep/ table td{
        background: #123333;
        color: #02E7E7;
    }
</style>
<template>
    <div class="zzuiTable font12">
        <!--表格公用组件模板-->
        <div style="height: 268px;" v-if="bool">
            <Table :height="height" stripe size="small" :disabled-hover="banHover"
                   :columns="columns" :data="dataTable.list" @on-selection-change="selectChange" @on-expand="expandTab">
            </Table>
            <div class="table-bottom" v-if="!pageHide">
                <div class="table-btmRight">
                    <Page :total="dataTable.page.totalCount"
                          @on-change="goPage"
                          :page-size="dataTable.page.pageSize"
                          :current="dataTable.page.currentPage"
                          @on-page-size-change="sizeChange"
                          size="small" show-elevator show-sizer
                    ></Page>
                </div>
            </div>
        </div>
        <div class="center p-t-40" v-else>正在加载...</div>
        <!--<div class="center p-t-40" v-else>查询不到任何相关数据</div>-->
    </div>
</template>
<script>
    export default {
        name:'private-table',
        /*@
        * param columnsList 表格标题字段
        * param dataTable 表格数据
        * param columnsProp 通过条件判断、判断表格配置项
        * param extendColumns 通过新增表格配置项
        * */
        props: {
            'columnsList': {
                type: [Array],
            },
            'dataTable': {
                type: [Object],
            },
            'columnsProp': {
                type: [String, Object],
            },
            'extendColumns': {
                type: [String, Object],
            },
            'extendWidth': {
                type: [Array, Object],
            },
            'pageHide': {
                type: [String, Boolean],
                default: false
            },
            'banHover': {
                type: Boolean,
                default: false
            },
            'height': {
                type: Number
            }
        },
        data() {
            return {
                bool: false,
                columns: [],
            }
        },
        watch: {
            dataTable() {
                if (this.dataTable.page && this.dataTable.list) this.formatData();
            }
        },
        methods: {
            /*列表格式化*/
            formatData() {
                let arr = [];
                this.columnsList.forEach((item, index) => {
                    let obj = {
                        // align: item.align ? item.align : "center",
                        ellipsis: item.ellipsis ? item.ellipsis : true,
                        tooltip:true,
                        render: (h, params) => {
                            return h('span', {
                                attrs: {
                                    title: params.row[item.key]
                                }
                            }, params.row[item.key])
                        }
                    };
                    Object.assign(obj,item);
                    arr.push(obj);
                });
                this.columns = arr;
                this.bool = true;
            },
            /*点击页码更换数据*/
            goPage(val) {
                this.$emit('getPageData', val);
            },
            selectChange (selection) {
                this.$emit('selectChange', selection);
            },
            expandTab(row,status){
                this.$emit('expandTab',{row,status});
            },
            sizeChange(val){
                 this.$emit('sizeChange',val);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/wit-electric-monitor/private-table.vue